import { render, staticRenderFns } from "./SpecialEMail.vue?vue&type=template&id=33a40148&"
import script from "./SpecialEMail.vue?vue&type=script&lang=js&"
export * from "./SpecialEMail.vue?vue&type=script&lang=js&"
import style0 from "./SpecialEMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports